import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import React from "react";

interface NotificationSectionProps {
	title: string;
	children: React.ReactNode;
}

export const NotificationSection = ({ title, children }: NotificationSectionProps): JSX.Element => (
	<>
		<SectionHeader>
			<Line />
			{title}
			<Line />
		</SectionHeader>
		{children}
	</>
);

const SectionHeader = styled.div`
	padding: 8px 0px;
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	gap: 16px;
	align-items: center;
`;

const Line = styled.div`
	height: 1px;
	background-color: ${colors.grey10};
`;
